<template>
  <div class="loading_container" v-if="loading">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only"></span>
    </div>
  </div>
</template>

<script>
import AssistantManager from "../../../js/services/assistant.js";
import Config from "../../../../resources/config.js";

export default {
  name: "SubscribePage",

  created() {
    this.goToSubscriptionPage();
  },

  components: {},

  data() {
    return {};
  },

  computed: {
    loading() {
      return this.$store.state.loading;
    },
  },

  methods: {
    async goToSubscriptionPage() {
      this.$store.commit("setLoading", true);
      let utm = this.$route.params.utm || null;
      let next = "";

      // fixme: improve checkout recovery method..
      if (utm === "ml-rnv") {
        next =
          "&utm_source=email&utm_medium=renovacao&utm_campaign=assinatura-virtapclub";
      } else if (utm === "ml-rcp") {
        next =
          "&utm_source=email&utm_medium=recuperacao&utm_campaign=assinatura-virtapclub";
      }

      try {
        let assistantData = await AssistantManager.getAssistantSignupData();
        if (!assistantData.logged_in) {
          window.location = Config.loginPage + "?next=assinar" + (utm ? `/${utm}` : "");
        } else {
          location.href = Config.purchasePage + "?p=VIRTAP_CLUB" + next;
        }
      } catch (error) {
        this.handleAPIError(error, null);
      }
    },
  },
};
</script>
